<template >
  <div class="container" v-if="lesson">
    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <div class="row">
          <div class="col">
            <h4>
              Групп:
              <span class="font-weight-bold">{{ lesson.name }}</span> - Группын
              бүлгүүд
              <span v-for="(group, index) in lesson.groups" :key="index">
                ,
                <span class="text-primary"
                  >{{ group.departmentName }}{{ group.programName }}</span
                >
              </span>
            </h4>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="py-3">
          <div>
            <div class="row">
              <div class="col-sm-12 col-md-3" v-if="school">
                <div class="form-group">
                  <label>Анги сонгоx</label>
                  <select class="form-control" v-model="department">
                    <option
                      v-for="dep in departments"
                      v-bind:key="dep.id"
                      v-bind:value="dep"
                    >
                      {{ dep.name }} анги
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-sm-12 col-md-3" v-if="school">
                <div class="form-group">
                  <label>Бүлэг сонгоx</label>
                  <select class="form-control" v-model="program">
                    <option
                      v-for="school in programs"
                      v-bind:key="school.id"
                      v-bind:value="school"
                    >
                      {{ school.name.toUpperCase() }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-sm-12 col-md-3">
                <label>.</label>
                <div class="form-group">
                  <button
                    class="btn btn-block btn-success"
                    @click="searchStudents"
                  >
                    Хайх
                  </button>
                </div>
              </div>
            </div>

            <hr />
          </div>

          <div class="row">
            <div class="col col-md-6 col-sm-12">
              <h5>Группын сурагчид</h5>
              <table
                class="table table-bordered"
                id="dataTable"
                width="100%"
                cellspacing="0"
                v-if="students != null && students.length > 0"
              >
                <thead>
                  <tr>
                    <th>№</th>
                    <th>Овог/Нэр</th>
                    <th>Үйлдэл</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(std, index) in nameSorted" v-bind:key="std.id">
                    <td>{{ index + 1 }}</td>
                    <td class="">
                      <span v-if="std.student">
                        <span
                          v-if="
                            std.student.lastname &&
                            std.student.lastname.length > 0
                          "
                        >
                          <span
                            v-if="
                              std.student.lncount &&
                              std.student.lncount > 1 &&
                              std.student.lastname.length >= std.student.lncount
                            "
                            >{{
                              std.student.lastname.substring(
                                0,
                                std.student.lncount
                              )
                            }}</span
                          >
                          <span v-else>{{ std.student.lastname[0] }}</span
                          >.
                        </span>
                        {{ std.student.name }}

                        <span
                          class="text-primary"
                          v-if="std.student.departmentData"
                          >{{ std.student.departmentData.name }}</span
                        >
                        <span
                          class="text-primary"
                          v-if="std.student.programData"
                          >{{ std.student.programData.name }}</span
                        >
                      </span>
                    </td>

                    <!-- <td>
                      <span v-if="std.student != null">{{
                        std.student.ref.path
                      }}</span>
                    </td> -->
                    <!-- <td><span v-if="std.student!=null">{{std.student.register}}</span></td> -->
                    <!-- <td>
                            <span v-if="std.enabled==true" class="badge badge-pill badge-success">идэвхтэй</span>
                            <span v-else class="badge badge-pill badge-danger">блоклосон</span>
                          </td> -->
                    <td>
                      <button
                        class="btn btn-sm btn-danger"
                        @click="removeStudent(std)"
                      >
                        хасах
                      </button>
                      <!-- <button v-if="std.enabled==true" class='btn btn-sm btn-primary  mx-1' @click="setEnabledForStudent(std, false)">эрх хаах</button> -->
                      <!-- <button v-else class='btn btn-sm btn-primary mx-1' @click="setEnabledForStudent(std, true)">эрх нээх</button> -->
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-else class="alert alert-info text-center">
                <p>Одоогоор энэ группд сурагч байхгүй байна.</p>
              </div>
            </div>

            <div class="col col-md-6 col-sm-12 scrollable">
              <h5>Хайлт</h5>
              <table
                class="table table-bordered"
                id="dataTable"
                width="100%"
                cellspacing="0"
                v-if="searchresults != null && searchresults.length > 0"
              >
                <thead>
                  <tr>
                    <th style="width: 1%">№</th>
                    <th>Овог/Нэр</th>
                    <th>Үйлдэл</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(std, index) in searchresults"
                    v-bind:key="std.id"
                    v-if="checkStudentIn(std) != true"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>
                      <span v-if="std != null">
                        <span v-if="std.lastname && std.lastname.length > 0">
                          <span
                            v-if="
                              std.lncount &&
                              std.lncount > 1 &&
                              std.lastname.length >= std.lncount
                            "
                            >{{ std.lastname.substring(0, std.lncount) }}</span
                          >
                          <span v-else>{{ std.lastname[0] }}</span
                          >.
                        </span>
                        <span style="color: black"> {{ std.name }}</span>
                      </span>
                    </td>
                    <td>
                      <!-- <button class='btn btn-sm btn-danger' @click="removeStudent(std)">хасах</button>
                          <button v-if="std.enabled==true" class='btn btn-sm btn-primary  mx-1' @click="setEnabledForStudent(std, false)">эрх хаах</button> -->
                      <div v-if="checkStudentIn(std) != true">
                        <button
                          class="btn btn-sm btn-primary mx-1"
                          @click="addSearchStudent(std)"
                        >
                          нэмэх
                        </button>
                      </div>
                      <div v-else>
                        <label class="badge badge-success">нэмэгдсэн</label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-else class="text-center alert alert-warning">
                <p>Одоогоор хайлтын мэдээлэл байхгүй байна.</p>
              </div>
            </div>
          </div>
        </div>

        <hr />
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "GroupStudent",

  data() {
    return {
      lesson: null,

      types: [],
      studentsText: "",
      selectedTopic: null,
      tmpStudents: [],
      students: [],
      searchresults: [],
      schools: [],
      departments: [],
      programs: [],
      school: null,
      department: null,
      program: null,
      semesters: [],
      selectedSemester: null,
      firstSet: false,

      tmpPrograms: [],
      tmpDepartments: [],
    };
  },
  watch: {
    school: function (val) {
      if (val && val.ref) {
        this.departments = [];
        this.programs = [];
        this.programyears = [];
        this.department = null;
        this.program = null;
        this.programYear = null;
        this._getDepartments(val);
      }
    },
    department: function (val) {
      if (val && val.ref) {
        this.programs = [];
        this.programyears = [];
        this.program = null;
        this.programYear = null;
        this._getPros(val);
      }
    },
    program: function (val) {
      if (val && val.ref) {
      }
    },
  },
  methods: {
    _getQA() {
      fb.db
        .collection("schools/" + this.schoolId + "/lessonGroups")
        .doc(this.lessonId)
        .onSnapshot((doc) => {
          let lesson = doc.data();
          lesson.id = doc.id;
          lesson.ref = doc.ref;
          lesson.schoolName = null;
          lesson.departmentName = null;
          lesson.programName = null;
          this.lesson = lesson;
        });

      fb.db
        .collection(
          "schools/" +
            this.schoolId +
            "/lessonGroups/" +
            this.lessonId +
            "/studentList"
        )
        .onSnapshot(async (querySnapshot) => {
          this.students = [];
          this.tmpPrograms = [];
          this.tmpDepartments = [];
          var tmp = [];
          for (const stddata of querySnapshot.docs) {
            let object = stddata.data();
            object.id = stddata.id;
            object.student = null;
            object.ref = stddata.ref;
            if (stddata.data().studentRef != null) {
              stddata
                .data()
                .studentRef.get()
                .then((studentDoc) => {
                  let student = studentDoc.data();
                  student.id = studentDoc.id;
                  student.ref = studentDoc.ref;
                  student.departmentData = null;
                  student.programData = null;
                  if (student["department-" + this.school.currentYear]) {
                    student["department-" + this.school.currentYear]
                      .get()
                      .then((ddoc) => {
                        if (ddoc.exists) {
                          student.departmentData = ddoc.data();
                        }
                      });
                  }

                  if (student["program-" + this.school.currentYear]) {
                    student["program-" + this.school.currentYear]
                      .get()
                      .then((ddoc) => {
                        if (ddoc.exists) {
                          student.programData = ddoc.data();
                        }
                      });
                  }
                  object.student = student;
                  // if(this.students && this.students>0){
                  //     this.students.sort(function(a, b) {
                  //       if(a.student && b.student)
                  //         return a.student.name == b.student.name ? 0 : +(a.student.name > b.student.name) || -1;
                  //     });
                  // }
                });
            }
            this.students.push(object);
          }
        });

      fb.db
        .collection(
          "schools/" +
            this.schoolId +
            "/lessonGroups/" +
            this.lessonId +
            "/studentList"
        )
        .onSnapshot(async (querySnapshot) => {
          this.tmpPrograms = [];
          this.tmpDepartments = [];
          for (const stddata of querySnapshot.docs) {
            let object = stddata.data();
            object.id = stddata.id;
            object.student = null;
            object.ref = stddata.ref;
            if (stddata.data().studentRef != null) {
              var studentDoc = await stddata.data().studentRef.get();

              let student = studentDoc.data();
              student.id = studentDoc.id;
              student.departmentData = null;
              student.programData = null;

              if (student.program) {
                var ddoc = await student[
                  "program-" + this.school.currentYear
                ].get();
                if (ddoc.exists) {
                  student.programData = ddoc.data();
                  let item = ddoc.data();
                  item.id = ddoc.id;
                  item.ref = ddoc.ref;
                  this.addTmpProgram(item);
                }
              }
              object.student = student;
            } //stddata.data().studentRef
          }

          this.check();
        });
    },

    checkModalShow() {
      if (this.tmpStudents.length == 0) $(".bd-example-modal-lg").modal("hide");
    },
    addStudentToLesson(lessonRef, studentData, studentDetail) {
      studentData.ref
        .collection("groupList")
        .doc(lessonRef.id)
        .get()
        .then((stLesson) => {
          if (stLesson != null && stLesson.exists) {
            alert("Сурагч өмнө нь нэмэгдсэн байна!");
          } else {
            studentData.ref
              .collection("groupList")
              .doc(lessonRef.id)
              .set({
                lessonRef: lessonRef,
                addedDate: new Date(),
                addedUser: fb.usersCollection.doc(
                  this.$store.getters.currentUser.uid
                ),
                enabled: true,
                startYear: this.school.currentYear,
                startMonth: this.school.currentYearStartMonth,
                currentSemesterNumber: this.school.currentSemesterNumber,
              })
              .then(() => {
                studentData.ref.update({
                  lessonGroups: fb.firestore.FieldValue.arrayUnion(lessonRef),
                });

                lessonRef
                  .collection("studentList")
                  .doc(studentData.id)
                  .get()
                  .then((lessonSt) => {
                    if (lessonSt != null && lessonSt.exists) {
                      alert("Аль хэдийн нэмэгдсэн байна.");
                    } else {
                      lessonRef.update({
                        numberOfStudents: fb.firestore.FieldValue.increment(1),
                      });
                      lessonRef
                        .collection("studentList")
                        .doc(studentData.id)
                        .set({
                          addedDate: new Date(),
                          addedUser: fb.usersCollection.doc(
                            this.$store.getters.currentUser.uid
                          ),
                          studentRef: studentData.ref,
                          enabled: true,
                        });
                    }
                  });
              });
          }
        });
    },

    setEnabledForStudent(stddata, value) {
      this.setProperty("enabled", stddata.ref, value);
      this.setProperty(
        "enabled",
        fb.db.doc(
          "schools/" +
            this.schoolId +
            "/students/" +
            stddata.id +
            "/groupList/" +
            this.lessonId
        ),
        value
      );
    },
    setProperty(propertyName, object, value) {
      if (object != null && propertyName != null) {
        var tmp = {};
        tmp[propertyName] = value;
        object.update(tmp);
      }
    },
    _checkAfterRemovingStudent() {
      console.log("checking....");
      console.log(this.tmpPrograms);
      this.tmpPrograms = [];
      this.tmpDepartments = [];
      for (var student of this.students) {
        //this.addTmpProgram(item);
      }
      console.log(this.tmpPrograms);
      //this.check()
    },
    removeStudent(stddata) {
      console.log(this.lesson.lesson, stddata.id);

      fb.db
        .doc(
          "schools/" +
            this.schoolId +
            "/students/" +
            stddata.id +
            "/groupList/" +
            this.lessonId
        )
        .delete()
        .then(() => {
          stddata.ref.delete();
        })
        .then(() => {
          fb.db
            .doc("schools/" + this.schoolId + "/students/" + stddata.id)
            .update({
              lessonGroups: fb.firestore.FieldValue.arrayRemove(
                fb.db
                  .collection("schools/" + this.schoolId + "/lessonGroups")
                  .doc(this.lessonId)
              ),
            })
            .then(() => {
              fb.db
                .collection("schools/" + this.schoolId + "/lessonGroups")
                .doc(this.lessonId)
                .update({
                  numberOfStudents: fb.firestore.FieldValue.increment(-1),
                });

              if (this.lesson.lesson != null) {
                this.lesson.lesson
                  .collection("studentList")
                  .doc(stddata.id)
                  .delete()
                  .then(() => {
                    stddata.studentRef
                      .collection("finalGrades")
                      .doc(this.lesson.lesson.id)
                      .delete();
                  });
              }
              this._checkAfterRemovingStudent();
            });
        });
    },
    _getDepartments(school) {
      if (school && school.ref) {
        school.ref
          .collection("departments")
          .where("startYear", "==", school.currentYear)
          .orderBy("index")
          .get()
          .then((docs) => {
            this.departments = [];
            docs.docs.forEach((doc) => {
              let object = doc.data();
              object.id = doc.id;
              object.ref = doc.ref;

              this.departments.push(object);
              if (
                this.firstSet != null &&
                this.firstSet != undefined &&
                this.firstSet != true &&
                this.departmentId &&
                object.id == this.departmentId
              ) {
                this.department = object;
              }
            });
          });
      }
    },
    _getPros(school) {
      if (school && school.ref) {
        school.ref
          .collection("programs")
          .orderBy("name")
          .get()
          .then((docs) => {
            this.programs = [];
            docs.docs.forEach((doc) => {
              let object = doc.data();
              object.id = doc.id;
              object.ref = doc.ref;
              this.programs.push(object);
            });
          });
      }
    },

    searchStudents() {
      var query = fb.db.collection("schools/" + this.schoolId + "/students");
      if (this.school) {
        if (this.department) {
          query = query.where(
            "department-" + this.school.currentYear,
            "==",
            this.department.ref
          );
        }
        if (this.program) {
          query = query.where(
            "program-" + this.school.currentYear,
            "==",
            this.program.ref
          );
        }
      }
      query = query.orderBy("name");

      if (query) {
        this.searchresults = [];
        query.get().then((docs) => {
          docs.docs.forEach((value) => {
            let object = value.data();
            object.id = value.id;
            object.ref = value.ref;
            object.departmentData = null;
            object.programData = null;

            if (object["department-" + this.school.currentYear]) {
              object["department-" + this.school.currentYear]
                .get()
                .then((ddoc) => {
                  if (ddoc.exists) object.departmentData = ddoc.data();
                });
            }

            if (object["department-" + this.school.currentYear]) {
              object["program-" + this.school.currentYear]
                .get()
                .then((ddoc) => {
                  if (ddoc.exists) object.programData = ddoc.data();
                });
            }
            this.searchresults.push(object);
          });
        });
      }
    },
    addSearchStudent(student) {
      if (student) {
        this.addStudentToLesson(
          fb.db
            .collection("schools/" + this.schoolId + "/lessonGroups")
            .doc(this.lessonId),
          student,
          null
        );
      }
    },
    checkStudentIn(student) {
      var result = false;
      if (student && this.students && this.students.length > 0) {
        for (const value of this.students) {
          if (value && value.student && value.student.id == student.id) {
            result = true;
            break;
          }
        }
      }
      return result;
    },
    addTmpProgram(program) {
      var exists = false;
      if (
        program &&
        program.id &&
        this.tmpPrograms &&
        this.tmpPrograms.length > 0
      ) {
        for (const currentprogram of this.tmpPrograms) {
          if (
            currentprogram &&
            currentprogram.id &&
            currentprogram.id == program.id
          ) {
            exists = true;
            break;
          }
        }
      }
      if (exists != true) {
        if (!this.tmpPrograms) this.tmpPrograms = [];
        this.tmpPrograms.push(program);
      }
    },
    async check() {
      if (this.tmpPrograms && this.tmpPrograms.length > 0) {
        var tmpGroups = [];
        for (const groupDepartment of this.tmpPrograms) {
          if (groupDepartment && groupDepartment.ref && groupDepartment.id) {
            var updateObject = {};
            var depDoc = await groupDepartment.ref.parent.parent.get();
            let depItem;
            if (depDoc && depDoc.exists) {
              depItem = depDoc.data();
              depItem.id = depDoc.id;
              depItem.ref = depDoc.ref;
            }
            if (depItem && depItem.id && depItem.ref) {
              if (depItem.name) {
                var indexNo = parseInt(depItem.name);
                updateObject.classNos =
                  fb.firestore.FieldValue.arrayUnion(indexNo);
              }
              if (depItem.ref) {
                updateObject.departments = fb.firestore.FieldValue.arrayUnion(
                  depItem.ref
                );
              }
            }

            if (groupDepartment && groupDepartment.id && groupDepartment.ref) {
              updateObject.programIds = fb.firestore.FieldValue.arrayUnion(
                groupDepartment.id
              );
              updateObject.programs = fb.firestore.FieldValue.arrayUnion(
                groupDepartment.ref
              );
              tmpGroups.push({
                school: fb.db.collection("schools").doc(this.schoolId),
                department: depItem && depItem.ref ? depItem.ref : null,
                program: groupDepartment.ref,
                departmentName: depItem && depItem.name ? depItem.name : null,
                programName: groupDepartment.name,
              });
            }
            await fb.db
              .collection("schools/" + this.schoolId + "/lessonGroups")
              .doc(this.lessonId)
              .update(updateObject);
          }
        }
        fb.db
          .collection("schools/" + this.schoolId + "/lessonGroups")
          .doc(this.lessonId)
          .update({ groups: tmpGroups });
      }
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    nameSorted: function () {
      if (this.students && this.students.length > 0) {
        return this.students.sort(function (a, b) {
          if (a.student && b.student)
            return a.student.name == b.student.name
              ? 0
              : +(a.student.name > b.student.name) || -1;
        });
      }
      return [];
    },
  },
  props: {
    lessonId: {
      required: true,
    },
    schoolId: {
      required: false,
    },
    departmentId: {
      required: false,
    },
  },
  created() {
    $("#sidebarToggle").trigger("click");
    fb.db
      .collection("schools")
      .doc(this.schoolId)
      .get()
      .then((doc) => {
        let school = doc.data();
        school.id = doc.id;
        school.ref = doc.ref;
        this.school = school;
      });

    if (this.lessonId != null && this.lessonId != "") this._getQA();
  },
  beforeDestroy() {
    $("#sidebarToggle").trigger("click");
  },
  filters: {
    formatDate(val) {
      if (val != null) {
        if (!val) {
          return "-";
        }
        let date = val.toDate();
        return moment(date).fromNow();
      }
      return "-";
    },
  },
};
</script>

<style>
.scrollable {
  height: 400px;
  overflow-y: scroll;
}
</style>